import request from '@/utils/request';
export function reviewList(data) {
  return request.post('admin/audit/application-review/list', data);
}
export function applicationVersionDetail(data) {
  return request.post('admin/audit/application-review/detail', data);
}
export function addApplicationVersion(data) {
  return request.post('admin/application-version/store', data);
}
export function applicationVersionSchedule(data) {
  return request.post('admin/audit/application-review/schedule', data);
}
export function reviewApprove(data) {
  return request.post('admin/audit/application-review/approve', data);
}
export const statusList = [{
  name: '审核中',
  id: 1
}, {
  name: '审核通过',
  id: 2
}, {
  name: '审核失败',
  id: 3
}];